$( document ).ready(function() {
    if(window.location.pathname === "/"){
      function initSearchAddress(){
        const input = document.getElementById("js-measurement-input");

        if (!input || !window.google || !google.maps || !google.maps.places) {
          return;
        }

        var options = {
          types: ['address'],
          componentRestrictions: {
            country: 'au'
          }
        };
        const autocomplete = new google.maps.places.Autocomplete(input,options);
        map_data.locateAddressMap = function (){
          map_data.place = autocomplete.getPlace();
          if (!map_data.place || !map_data.place.geometry || !map_data.place.geometry.location) {
            window.alert("No details available for: " + input.value );
            return false;
          }
          map_data.postcode = getPostalCode(map_data.place.address_components);
          map_data.address_components = map_data.place.address_components;
          return true;
        };
      }
      initSearchAddress();
    }

  if (window.google && google.maps && document.getElementById('location')) {
    google.maps.event.addDomListener(window, 'load', initialize);
  }
});

try {
if(typeof map_data !== 'undefined' && map_data && window.GoTurfServicePostcodes)
  map_data.list_postcodes = window.GoTurfServicePostcodes;
}catch(e) {}


// Basic google maps area calculator, TODO: still needs a way to delete vertices, calculate when updating area, delete set area, undo last vertice & delete all verticies

// (SO example with multiple areas) https://stackoverflow.com/questions/50160476/getting-the-area-of-a-polygon-using-the-overlay-complete-function
// (Example) https://www.daftlogic.com/projects-google-maps-area-calculator-tool.htm#
// (google maps drawing docs) https://developers.google.com/maps/documentation/javascript/examples/drawing-tools#all



var locateAddressMap = null;
var getPostcode = function () { return false; };
var tryGetAddress = function () { return false; };

function getPostalCode(addressComponents) {
    var postcode = addressComponents && addressComponents.find(function(component) {
        return component.types.indexOf('postal_code') !== -1;
    });

    return postcode ? postcode.long_name : '';
}

function createPolygonDrawingManager(map, polygonOptions) {
    var activePolygon = null;
    var activePath = null;
    var drawingMode = null;
    var mapListeners = [];
    var lastHandledClick = null;
    var previousDoubleClickZoom = map.get('disableDoubleClickZoom');

    function randomColor() {
        return "#" + ("000000" + Math.floor(Math.random() * 16777215).toString(16)).slice(-6);
    }

    function setPathArea(path) {
        path.area = path.getLength() >= 3 ? calculatePolyArea(null, path) : 0;
        path.color = path.color || polygonOptions.strokeColor;
    }

    function handlePathChange(path) {
        setPathArea(path);

        if (window.measure_page) {
            measure_page.calculateAreas();
        }
    }

    function bindPathUpdates(path) {
        google.maps.event.addListener(path, 'set_at', function() {
            handlePathChange(path);
        });
        google.maps.event.addListener(path, 'insert_at', function() {
            handlePathChange(path);
        });
        google.maps.event.addListener(path, 'remove_at', function() {
            handlePathChange(path);
        });
    }

    function isNearFirstPoint(latLng) {
        if (!activePath || activePath.getLength() < 3 || !google.maps.geometry) {
            return false;
        }

        return google.maps.geometry.spherical.computeDistanceBetween(activePath.getAt(0), latLng) < 2;
    }

    function recentlyHandled(latLng) {
        if (!lastHandledClick || !google.maps.geometry) {
            return false;
        }

        return Date.now() - lastHandledClick.time < 100 &&
            google.maps.geometry.spherical.computeDistanceBetween(lastHandledClick.latLng, latLng) < 0.1;
    }

    function handleDrawingClick(event) {
        if (drawingMode !== 'polygon' || recentlyHandled(event.latLng)) {
            return;
        }

        lastHandledClick = {
            latLng: event.latLng,
            time: Date.now()
        };
        addPoint(event.latLng);
    }

    function finishFromLatLng(latLng) {
        if (drawingMode !== 'polygon' || !activePath) {
            return;
        }

        var lastIndex = activePath.getLength() - 1;
        var lastPoint = activePath.getAt(lastIndex);
        if (lastIndex >= 3 && google.maps.geometry && google.maps.geometry.spherical.computeDistanceBetween(lastPoint, latLng) < 2) {
            activePath.removeAt(lastIndex);
        }

        finishActive();
    }

    function ensureActivePolygon() {
        if (activePolygon) {
            return;
        }

        var strokeColor = randomColor();
        activePolygon = new google.maps.Polygon(Object.assign({}, polygonOptions, {
            strokeColor: strokeColor,
            map: map
        }));
        activePath = activePolygon.getPath();
        activePath.color = strokeColor;
        bindPathUpdates(activePath);

        google.maps.event.addListener(activePolygon, 'click', handleDrawingClick);
        google.maps.event.addListener(activePolygon, 'dblclick', function(event) {
            finishFromLatLng(event.latLng);
        });
    }

    function addPoint(latLng) {
        if (isNearFirstPoint(latLng)) {
            finishActive();
            return;
        }

        ensureActivePolygon();
        activePath.push(latLng);
        setPathArea(activePath);
    }

    function finishActive() {
        if (!activePolygon || !activePath || activePath.getLength() < 3) {
            return false;
        }

        setPathArea(activePath);
        map_data.overlays.push({
            type: 'polygon',
            overlay: activePolygon
        });
        activePolygon = null;
        activePath = null;

        if (window.measure_page) {
            measure_page.calculateAreas();
        }

        setDrawingMode(null);
        return true;
    }

    function clearActive() {
        if (activePolygon) {
            activePolygon.setMap(null);
        }

        activePolygon = null;
        activePath = null;
    }

    function enableDrawing() {
        if (mapListeners.length) {
            return;
        }

        previousDoubleClickZoom = map.get('disableDoubleClickZoom');
        map.setOptions({
            disableDoubleClickZoom: true,
            draggableCursor: 'crosshair'
        });

        mapListeners.push(google.maps.event.addListener(map, 'click', handleDrawingClick));

        mapListeners.push(google.maps.event.addListener(map, 'dblclick', function(event) {
            finishFromLatLng(event.latLng);
        }));
    }

    function disableDrawing() {
        mapListeners.forEach(function(listener) {
            listener.remove();
        });
        mapListeners = [];
        map.setOptions({
            disableDoubleClickZoom: previousDoubleClickZoom,
            draggableCursor: null
        });
    }

    function setDrawingMode(nextDrawingMode) {
        drawingMode = nextDrawingMode;

        if (drawingMode === 'polygon') {
            enableDrawing();
        } else {
            disableDrawing();
        }
    }

    return {
        setDrawingMode: setDrawingMode,
        finishActive: finishActive,
        clearActive: clearActive
    };
}

function initMap() {
    const input = document.getElementById("js-measurement-input");
    const mapElement = document.getElementById("map");

    if (!input || !mapElement) {
        return;
    }

    const map = new google.maps.Map(mapElement, {
        center: { lat: -27.452513, lng: 153.020449 },
        zoom: 16,
        disableDefaultUI: true,
        zoomControl: true,
        mapTypeId: google.maps.MapTypeId.HYBRID
    });

    const polygonOptions = {
        fillColor: "#4ee44e",
        fillOpacity: 0.75,
        strokeColor: "#e44e4e",
        strokeWeight: 3,
        clickable: true,
        editable: true,
        zIndex: 1,
    };
    const drawingManager = createPolygonDrawingManager(map, polygonOptions);
    map_data.drawingManager = drawingManager;

    var options = {
        types: ['address'],
        componentRestrictions: {
            country: 'au'
        }
    };
  
    const autocomplete = new google.maps.places.Autocomplete(input,options);

    autocomplete.bindTo("bounds", map);

    getPostcode = function (){
        const place = autocomplete.getPlace();
        if (!place || !place.geometry || !place.geometry.location) {
            window.alert("No details available for: " + input.value );
            return false;
        }
        map_data.postcode = getPostalCode(place.address_components);
        return true;
    };

    tryGetAddress = function (){
		var geocoder = new google.maps.Geocoder();
        geocoder.geocode({"address": input.value }, function(results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            map.setCenter(results[0].geometry.location);
            map_data.postcode = getPostalCode(results[0].address_components);
            map_data.address_components = results[0].address_components;
            measure_page.verifyPostcode(map_data.postcode);
            map.setZoom(20);
          }
        });
        return input.value;
    }

    measure_page.searchAdress();
}

function initialize() {
    var input = document.getElementById('location');

    if (!input) {
        return;
    }

    var options = {
        types: ['address'],
        componentRestrictions: {
            country: 'au'
        }
    };
  
    var autocomplete = new google.maps.places.Autocomplete(input, options);
  
    google.maps.event.addListener(autocomplete, 'place_changed', function() {
      console.log(autocomplete);
      var place = autocomplete.getPlace();
      var address = place.formatted_address;
      measure_page.validateAddress(place);
    });
}


function calculatePolyArea(event, path = null) {
    var polygonPath = !path ? event.overlay.getPath() : path;
    return google.maps.geometry.spherical.computeArea(
        typeof polygonPath.getArray === 'function' ? polygonPath.getArray() : polygonPath
    );
}


function calculateAreasMap(){
    map_data.overlays.forEach((value,key)=>{
        value.overlay.getPath().area = this.calculatePolyArea(value);
    });
    measure_page.calculateAreas();
}
